import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "./styles.scss";
import { Autoplay } from "swiper";
import CouponItem from "../Coupons/item";
// import Title from "../Title";
import { checkIfValidDate } from "../../utils/helper";

function CouponFileReader(props) {
  const { filename, title, logo, bgColor, theme, name, loop = false } = props;
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(process.env.PUBLIC_URL + filename);

      const text = await response?.text();
      const lines = text?.trim()?.split("\n");
      const headers = lines?.[0]?.split("|");
      const data = lines?.slice(1)?.map((line) => line?.split("|"));
      const formattedData = data?.map((line) => {
        const row = {};
        headers?.forEach((header, i) => {
          row[header] = line?.[i];
        });
        return row;
      });

      if (lines?.[0]?.toLocaleLowerCase()?.includes("<!doctype html>")) {
        setTableData([]);
      } else {
        setTableData(formattedData);
      }
    };

    fetchData();
  }, [filename]);

  //   const breakpoints = {
  //     // when window width is <= 640px
  //     0: {
  //       autoplay: {
  //         delay: 3500,
  //         disableOnInteraction: true,
  //         // allowTouchMove: true,
  //       },
  //     },
  //     // when window width is <= 768px
  //     769: {
  //       autoplay: {
  //         delay: 3500,
  //         disableOnInteraction: false,
  //         // allowTouchMove: false,
  //       },
  //     },
  //   };

  return (
    Array.isArray(tableData) &&
    tableData?.length > 0 &&
    !!tableData && (
      <div className="CouponFileReader coupons m-top-0">
        <div className="title-of-coupons">{title}</div>
        {/* <Title className="title-of-coupons" content={title} /> */}
        <Swiper
          //   autoHeight={true}
          //   breakpoints={breakpoints}
          //   simulateTouch={true}
          //   allowTouchMove={true}
          loop={loop}
          freeMode
          slidesPerView={"auto"}
          spaceBetween={0}
          modules={[Autoplay]}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
        >
          {tableData?.map((item, index) => {
            item.logo = logo;
            item.bgColor = bgColor;
            item.theme = theme;
            item.Name = name;
            item.website = item?.Store?.replaceAll("\r", "");
            // console.log("item.website:", item.website);
            const shouldRenderSlide = item?.["Start Date"]
              ? checkIfValidDate(item)
              : true;
            return (
              shouldRenderSlide && (
                <SwiperSlide key={index} style={{ width: "auto" }}>
                  <CouponItem item={item} />
                </SwiperSlide>
              )
            );
          })}
        </Swiper>
      </div>
    )
  );
}

export default CouponFileReader;

// import React, { useState, useEffect } from "react";

// function CouponFileReader(props) {
//   const { filename } = props;
//   const [tableData, setTableData] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       const response = await fetch(process.env.PUBLIC_URL + filename);
//       const text = await response?.text();

//       const lines = text?.trim()?.split("\n");
//       const headers = lines?.[0]?.split("|");
//       const data = lines?.slice(1)?.map((line) => line?.split("|"));
//       const formattedData = data?.map((line) => {
//         const row = {};
//         headers?.forEach((header, i) => {
//           row[header] = line?.[i];
//         });
//         return row;
//       });
//       setTableData(formattedData);
//     };

//     fetchData();
//   }, []);

//   return (
//     Array.isArray(tableData) &&
//     tableData?.length > 0 &&
//     !!tableData && (
//       <table>
//         <thead>
//           <tr>
//             {Object?.keys(tableData?.[0])?.map((header) => (
//               <th key={header}>{header}</th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {tableData?.map((row, i) => (
//             <tr key={i}>
//               {/* <td>{row?.Id}</td> */}
//               <td>{row?.Title}</td>
//               <td>{row?.Description}</td>
//               <td>{row?.URL}</td>
//               {/* <td>{row?.Category}</td> */}
//               {/* <td>{row?.Commission}</td> */}
//               <td>{row["Coupon Code"]}</td>
//               <td>{row["Date Start"]}</td>
//               <td>{row["Date End"]}</td>
//               {/* <td>{row["Edit Date"]}</td> */}
//               {/* <td>{row["Publish Date"]}</td> */}
//               {/* <td>{row["Is Public"]}</td> */}
//               {/* <td>{row?.Store}</td> */}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     )
//   );
// }

// export default CouponFileReader;
